module.exports = __webpack_public_path__ + "img/easyShyftLight.9ddff24a.png";